import moment from "moment/moment";
import { BudgetPeriod } from "@/services/cloudchipr.api";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { getFQuarterByStartMonth } from "@/components/common/date-range-picker/utils/preDefinedRanges/getQuarterlyPreDefinedRange";

export const getBudgetDetailsHistoryFormatedDate = (
  date?: string | number,
  period?: BudgetPeriod,
  quarterStartMonth?: number,
) => {
  if (period === "monthly") {
    return formatDate(`${date}`, {
      type: "monthNameYear",
    });
  }

  if (period === "daily" || period === "custom") {
    return formatDate(`${date}`, {
      type: "dayMonthName",
    });
  }

  if (period === "annually") {
    return formatDate(`${date}`, {
      type: "year",
    });
  }

  const dateMoment = moment(date);
  const year = dateMoment.year();

  const { quarter } = getFQuarterByStartMonth(
    dateMoment.month() + 1,
    quarterStartMonth,
  );

  return `Q${quarter} ${year}`;
};
